import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import "font-awesome/css/font-awesome.min.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import HireDeveloper from "./pages/hiredeveloper";
import GetHire from "./pages/gethire";
import GetHireDeveloper from "./pages/gethiredeveloper";
import ScrollToTop from "./pages/ScrollToTop";
import Thankyou from "./pages/thankyou";
import Hiredevelopers from "./pages/hiredevelopers";
import Contactus from "./pages/contactus";
// import Twak from "./component/Twak";
import NotFound from "./pages/NotFound";

AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});

function App() {
  return (
    <>
      <Router>
        <ScrollToTop>
          {/* <Twak /> */}
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="hiredeveloper" element={<HireDeveloper />}></Route>
            <Route path="gethire" element={<GetHire />}></Route>
            <Route
              path="gethiredeveloper"
              element={<GetHireDeveloper />}
            ></Route>
            <Route path="thankyou/:id" element={<Thankyou />}></Route>
            <Route path="hiredevelopers" element={<Hiredevelopers />}></Route>
            <Route path="contactus" element={<Contactus />}></Route>
            <Route path="*" element={<NotFound />}></Route>
          </Routes>
        </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
